import { ThemeProvider } from '@mui/material/styles';
import { AdminInterceptProvider } from '@revenuewell/logic-oidc';
import { NotificationsProvider } from '@revenuewell/uc-notifications-client';
import { ProductsByLocationProvider } from 'apps/wrapper/src/hooks/use-products-by-location';
import { TodaysItemsProvider } from 'apps/wrapper/src/hooks/use-todays-items/use-todays-items';
import React from 'react';
import { FeatureFlagProvider } from '../../../hooks/feature-flags/use-feature-flags';
import { AlertsProvider } from '../../../hooks/use-alerts';
import { CommsChatProvider, CommsFilterProvider, CommunicationsProvider } from '../../../hooks/use-communications';
import { ContactsProvider } from '../../../hooks/use-contacts';
import { EventBusProvider } from '../../../hooks/use-event-bus';
import { FaxProvider } from '../../../hooks/use-fax/use-fax';
import HistoryInterceptProvider from '../../../hooks/use-history-intercept';
import { InboxFilterProvider, InboxPreviewProvider } from '../../../hooks/use-inbox';
import { InsuranceAlertsProvider } from '../../../hooks/use-insurance-alerts/use-insurance-alerts';
import { Intercom } from '../../../hooks/use-intercom';
import { KazooProvider } from '../../../hooks/use-kazoo/use-kazoo';
import { LocationsProvider } from '../../../hooks/use-locations';
import { MessengerNotificationProvider } from '../../../hooks/use-messenger-notification/use-messenger-notification';
import { PracticePayersProvider } from '../../../hooks/use-practice-payers';
import { PubnubProvider } from '../../../hooks/use-pubnub/use-pubnub';
import { SearchProvider } from '../../../hooks/use-search/use-search';
import { SettingsProvider } from '../../../hooks/use-settings';
import ViewModeProvider from '../../../hooks/use-view-mode/provider';
import { VoicemailProvider } from '../../../hooks/use-voicemail/use-voicemail';
import { ApptRequestIvProvider } from '../../insurance-verification/appt-request-flow/hooks/use-appt-request-iv/provider';
import { PatientIvProvider } from '../../insurance-verification/patient-flow/hooks/use-patient-iv/provider';
import { theme } from '../../shared/material-theme';
import { SlideOutCardProvider } from '../../shared/slide-out-card/provider';
import { ConditionalLegacyPhoneProviders } from './conditional-legacy-phone-providers';
import { ConditionalPhoneProviders } from './conditional-phone-providers';

interface AppProvidersProps {
  children: React.ReactElement;
}

export default function AppProviders(props: AppProvidersProps) {
  return (
    <AdminInterceptProvider>
      <HistoryInterceptProvider>
        <SlideOutCardProvider>
          <EventBusProvider>
            <ViewModeProvider>
              <SettingsProvider>
                <FeatureFlagProvider>
                  <LocationsProvider>
                    <ProductsByLocationProvider>
                      <ContactsProvider>
                        <KazooProvider>
                          <ConditionalPhoneProviders>
                            <ConditionalLegacyPhoneProviders>
                              <VoicemailProvider>
                                <FaxProvider>
                                  <PubnubProvider>
                                    <Intercom>
                                      <MessengerNotificationProvider>
                                        <NotificationsProvider>
                                          <TodaysItemsProvider>
                                            <InsuranceAlertsProvider>
                                              <PracticePayersProvider>
                                                <AlertsProvider>
                                                  <PatientIvProvider>
                                                    <ApptRequestIvProvider>
                                                      <InboxPreviewProvider>
                                                        <CommsFilterProvider>
                                                          <InboxFilterProvider>
                                                            <CommunicationsProvider>
                                                              <CommsChatProvider>
                                                                <SearchProvider>
                                                                  <ThemeProvider theme={theme}>
                                                                    {props.children}
                                                                  </ThemeProvider>
                                                                </SearchProvider>
                                                              </CommsChatProvider>
                                                            </CommunicationsProvider>
                                                          </InboxFilterProvider>
                                                        </CommsFilterProvider>
                                                      </InboxPreviewProvider>
                                                    </ApptRequestIvProvider>
                                                  </PatientIvProvider>
                                                </AlertsProvider>
                                              </PracticePayersProvider>
                                            </InsuranceAlertsProvider>
                                          </TodaysItemsProvider>
                                        </NotificationsProvider>
                                      </MessengerNotificationProvider>
                                    </Intercom>
                                  </PubnubProvider>
                                </FaxProvider>
                              </VoicemailProvider>
                            </ConditionalLegacyPhoneProviders>
                          </ConditionalPhoneProviders>
                        </KazooProvider>
                      </ContactsProvider>
                    </ProductsByLocationProvider>
                  </LocationsProvider>
                </FeatureFlagProvider>
              </SettingsProvider>
            </ViewModeProvider>
          </EventBusProvider>
        </SlideOutCardProvider>
      </HistoryInterceptProvider>
    </AdminInterceptProvider>
  );
}
